import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      // Navigation
      'Home': 'الرئيسية',
      'About': 'من أنا',
      'About Me': 'من أنا',
      'Dashboard': 'لوحة التحكم',
      'Login': 'تسجيل الدخول',
      'Register': 'إنشاء حساب',
      'Logout': 'تسجيل الخروج',
      'Go to Dashboard': 'اذهب إلى لوحة التحكم',
      
      // Common
      'Save': 'حفظ',
      'Cancel': 'إلغاء',
      'Edit': 'تعديل',
      'Delete': 'حذف',
      'Add': 'إضافة',
      'Update': 'تحديث',
      'Loading...': 'جاري التحميل...',
      'Error': 'خطأ',
      'Success': 'نجح',
      
      // Authentication
      'Back to home': 'العودة إلى الرئيسية',
      'welcomeBack': 'مرحباً بعودتك',
      'signInToManageStories': 'سجل دخولك لإدارة قصصك',
      'Email': 'البريد الإلكتروني',
      'Enter your email': 'أدخل بريدك الإلكتروني',
      'Password': 'كلمة المرور',
      'Enter your password': 'أدخل كلمة المرور',
      'signingIn': 'جاري تسجيل الدخول...',
      'signIn': 'تسجيل الدخول',
      'dontHaveAccount': 'ليس لديك حساب؟',
      'signUpHere': 'سجل هنا',
      'Welcome back! ✨': 'مرحباً بعودتك! ✨',
      'joinYourLittleCorner': 'انضم إلى زاويتك الصغيرة',
      'createYourAccountAndStartSharingStories': 'أنشئ حسابك وابدأ مشاركة قصصك',
      'Name': 'الاسم',
      'Enter your name': 'أدخل اسمك',
      'Confirm Password': 'تأكيد كلمة المرور',
      'Re-enter your password': 'أعد كتابة كلمة المرور',
      'Passwords do not match': 'كلمات المرور غير متطابقة',
      'Password must be at least 6 characters long': 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
      'creatingAccount': 'جاري إنشاء الحساب...',
      'createAccount': 'إنشاء حساب',
      'alreadyHaveAnAccount': 'لديك حساب بالفعل؟',
      'signInHere': 'سجل دخولك هنا',
      
      // Home Page
      'aPlaceWhereThoughtsBloom': 'مكان تتفتح فيه الأفكار والكلمات مثل الزهور في الربيع',
      'discoverStoriesThatTouchTheHeart': 'اكتشف القصص التي تلمس القلب',
      'Latest Stories': 'أحدث القصص',
      'No stories yet': 'لا توجد قصص بعد',
      'First story brewing': 'القصة الأولى قيد التحضير مثل كوب شاي مثالي. قريباً، ستملأ الكلمات الجميلة هذا المكان بالدفء والدهشة.',
      'Coming soon...': 'قريباً...',
      'thoughts': 'أفكار',
      'Read More': 'اقرأ المزيد',
      'Previous': 'السابق',
      'Next': 'التالي',
      'Ready to Share Your Story?': 'هل أنت مستعد لمشاركة قصتك؟',
      'Every heart has a story to tell. Join me in this beautiful journey of words and emotions.': 'كل قلب له قصة يرويها. انضم إلي في هذه الرحلة الجميلة من الكلمات والمشاعر.',
      'Let\'s create something beautiful together': 'دعنا نخلق شيئاً جميلاً معاً',
      'Loading beautiful stories...': 'جاري تحميل القصص الجميلة...',
      'Error Loading Posts': 'خطأ في تحميل المنشورات',
      'Try Again': 'حاول مرة أخرى',
      
      // Post Detail Page
      'Loading your story...': 'جاري تحميل قصتك...',
      'Story not found': 'القصة غير موجودة',
      'This story might have been moved or doesn\'t exist yet.': 'قد تكون هذه القصة قد نُقلت أو لا توجد بعد.',
      'Back to Home': 'العودة إلى الرئيسية',
      'Back to Stories': 'العودة إلى القصص',
      'Thank you for reading': 'شكراً لقراءتك',
      'Every story here is a piece of my heart that I share with love. I hope it touched your heart too.': 'كل قصة هنا هي قطعة من قلبي أشاركها معكم بمحبة. أتمنى أن تكون قد لامست قلبك أيضاً.',
      'Read More Stories': 'اقرأ المزيد من القصص',
      
      // Profile Management
      'Profile Management': 'إدارة الملف الشخصي',
      'Manage your personal information and interests': 'إدارة معلوماتك الشخصية واهتماماتك',
      'Personal Information': 'المعلومات الشخصية',
      'Save Profile': 'حفظ الملف الشخصي',
      'Saving...': 'جاري الحفظ...',
      'Name': 'الاسم',
      'Age': 'العمر',
      'City': 'المدينة',
      'Preferred Language': 'اللغة المفضلة',
      'Bio': 'نبذة شخصية',
      'Life Philosophy': 'فلسفة الحياة',
      'Life Story': 'قصة حياتي',
      'Interests': 'الاهتمامات',
      'Add Interest': 'إضافة اهتمام',
      'Edit Interest': 'تعديل الاهتمام',
      'Add New Interest': 'إضافة اهتمام جديد',
      'Title': 'العنوان',
      'Description': 'الوصف',
      'Icon (optional)': 'الأيقونة (اختياري)',
      'Interest title': 'عنوان الاهتمام',
      'Describe your interest...': 'صف اهتمامك...',
      'e.g., heart, book, music': 'مثال: قلب، كتاب، موسيقى',
      'No interests added yet. Add your first interest above!': 'لم يتم إضافة اهتمامات بعد. أضف اهتمامك الأول أعلاه!',
      'Please enter your name': 'يرجى إدخال اسمك',
      'Please enter a title for the interest': 'يرجى إدخال عنوان للاهتمام',
      'Profile updated successfully!': 'تم تحديث الملف الشخصي بنجاح!',
      'Interest added successfully!': 'تم إضافة الاهتمام بنجاح!',
      'Interest updated successfully!': 'تم تحديث الاهتمام بنجاح!',
      'Interest deleted successfully!': 'تم حذف الاهتمام بنجاح!',
      'Failed to load profile data': 'فشل في تحميل بيانات الملف الشخصي',
      'Failed to update profile': 'فشل في تحديث الملف الشخصي',
      'Failed to save interest': 'فشل في حفظ الاهتمام',
      'Failed to delete interest': 'فشل في حذف الاهتمام',
      'Are you sure you want to delete this interest?': 'هل أنت متأكد من حذف هذا الاهتمام؟',
      
      // About Page
      'Who Am I': 'من أنا',
      'My Story': 'قصتي',
      'My Interests': 'اهتماماتي',
      'Welcome to My Blog': 'مرحباً بكم في مدونتي',
      'Blog writer and storyteller': 'كاتبة مدونة وروائية',
      'years old': 'سنة',
      'Profile not found': 'لم يتم العثور على الملف الشخصي',
      'Loading profile...': 'جاري تحميل الملف الشخصي...',
      
      // Dashboard
      'Back to Blog': 'العودة إلى المدونة',
      'Manage your stories and create new ones': 'إدارة قصصك وإنشاء قصص جديدة',
      'New Post': 'منشور جديد',
      'Total Posts': 'إجمالي المنشورات',
      'Published Posts': 'المنشورات المنشورة',
      'Drafts': 'المسودات',
      'Total Views': 'إجمالي المشاهدات',
      'Create New Post': 'إنشاء منشور جديد',
      'Edit Post': 'تعديل المنشور',
      'Excerpt': 'ملخص',
      'Content': 'المحتوى',
      'Featured Image': 'الصورة المميزة',
      'Upload Image File': 'رفع ملف صورة',
      'Max size: 5MB. Supported formats: JPG, PNG, GIF': 'الحد الأقصى: 5 ميجابايت. الصيغ المدعومة: JPG, PNG, GIF',
      'Status': 'الحالة',
      'Draft': 'مسودة',
      'Published': 'منشور',
      'Publish': 'نشر',
      'Your Posts': 'منشوراتك',
      'No posts yet': 'لا توجد منشورات بعد',
      'Start writing your first story and share your thoughts with the world!': 'ابدأ بكتابة قصتك الأولى وشارك أفكارك مع العالم!',
      'Create Your First Post': 'أنشئ منشورك الأول',
      'View Post': 'عرض المنشور',
      'Please enter a title for your post': 'يرجى إدخال عنوان لمنشورك',
      'Please upload a valid image file.': 'يرجى رفع ملف صورة صالح.',
      'Post created successfully!': 'تم إنشاء المنشور بنجاح!',
      'Post updated successfully!': 'تم تحديث المنشور بنجاح!',
      'Post deleted successfully!': 'تم حذف المنشور بنجاح!',
      'Failed to save post. Please try again.': 'فشل في حفظ المنشور. يرجى المحاولة مرة أخرى.',
      'Are you sure you want to delete this post?': 'هل أنت متأكد من حذف هذا المنشور؟',
      'Failed to delete post. Please try again.': 'فشل في حذف المنشور. يرجى المحاولة مرة أخرى.',
      'Failed to load post content for editing': 'فشل في تحميل محتوى المنشور للتعديل',
      'Failed to load posts': 'فشل في تحميل المنشورات',
      'Not published': 'غير منشور',
      'views': 'مشاهدات',
      'Total Likes': 'إجمالي الإعجابات',
      
      // 404 Page
      'Page Not Found': 'الصفحة غير موجودة',
      'Oops! The page you\'re looking for seems to have wandered off into the digital wilderness.': 'عذراً! يبدو أن الصفحة التي تبحث عنها قد ضاعت في البرية الرقمية.',
      'Don\'t worry, even the best stories sometimes take unexpected paths.': 'لا تقلق، حتى أفضل القصص تأخذ أحياناً مسارات غير متوقعة.',
      'Back to Home': 'العودة إلى الرئيسية',
      'Every journey has its detours': 'كل رحلة لها انعطافاتها',
      'Sometimes the most beautiful discoveries happen when we take the road less traveled.': 'أحياناً تحدث أجمل الاكتشافات عندما نسلك الطريق الأقل سفراً.',
      'You might also be looking for:': 'قد تكون أيضاً تبحث عن:',
      
      // Form Placeholders
      'Your name': 'اسمك',
      'Your age': 'عمرك',
      'Your city': 'مدينتك',
      'Tell us about yourself...': 'أخبرنا عن نفسك...',
      'Share your life philosophy and beliefs...': 'شارك فلسفتك في الحياة ومعتقداتك...',
      'Share your life story and experiences...': 'شارك قصة حياتك وتجربتك...',
      'Write your story here... Let your thoughts flow naturally and share what\'s in your heart.': 'اكتب قصتك هنا... دع أفكارك تتدفق طبيعياً وشارك ما في قلبك.',
      
      // Language Options
      'العربية': 'العربية',
      'English': 'English',
      'Language': 'اللغة',
      'views': 'مشاهدات',
      'likes': 'الإعجابات',
      
      // Analytics
      'Analytics': 'الإحصائيات',
      'UTM Traffic Analytics': 'إحصائيات مصادر الزوار',
      'No traffic data yet': 'لا توجد بيانات زيارات بعد',
      'Share your blog with UTM links to see analytics here.': 'شارك مدونتك بروابط UTM لتظهر التحليلات هنا.',
      'Visits per Day': 'الزيارات حسب اليوم',
      'Total Visits by Source': 'إجمالي الزيارات حسب المصدر',
      // Filter Bar
      'Type': 'النوع',
      'All': 'الكل',
      'Category': 'التصنيف',
      'No categories yet': 'لا توجد تصنيفات بعد'
    }
  },
  en: {
    translation: {
      views: 'Views',
      likes: 'Likes',
      'Who Am I': 'Who Am I',
      'Analytics': 'Analytics',
      'UTM Traffic Analytics': 'UTM Traffic Analytics',
      'No traffic data yet': 'No traffic data yet',
      'Share your blog with UTM links to see analytics here.': 'Share your blog with UTM links to see analytics here.',
      'Visits per Day': 'Visits per Day',
      'Total Visits by Source': 'Total Visits by Source',
      'Type': 'Type',
      'All': 'All',
      'Category': 'Category',
      'No categories yet': 'No categories yet'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar', // default language
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false,
    },
  });

document.documentElement.dir = 'rtl';
document.body.dir = 'rtl';

export default i18n; 